import { NVButton } from '@nv/basic-components'
import EditIcon from '@nv/images/design/edit-icon'
import PwEyeIcon from '@nv/images/design/pw-eye-icon'
import PipscLogoCollapsed from '@nv/images/logos/pipsc-voter-portal/pipsc-logo-collapsed'
import GoogleIcon from '@nv/images/thirdparty/google-icon'
import LinkedinIcon from '@nv/images/thirdparty/linkedin-icon'
import YoutubeIcon from '@nv/images/thirdparty/youtube-icon'
import { useTranslation } from 'react-i18next'
import Skeleton from '../skeleton/Skeleton'
import styles from './CandidateLinks.module.scss'

export const CandidateLinks = ({ editEnabled, links, loading, openCandidateLinksEditModal }: any) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const iconMap = {
    pipsc: <PipscLogoCollapsed />,
    linkedin: <LinkedinIcon />,
    youtube: <YoutubeIcon />,
    google: <GoogleIcon />,
    googleSheets: <GoogleIcon />,
  }

  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        <h2>{t('main.links')}</h2>
        {editEnabled && (
          <NVButton
            variant='text'
            onClick={() => openCandidateLinksEditModal()}
            text={links.length ? t('buttons.edit') : t('buttons.addLinks')}
            icon={<EditIcon />}
          />
        )}
      </div>

      {loading ? (
        <>
          <Skeleton width={300} height={30} />
          <br />
          <br />
          <Skeleton width={300} height={30} />
          <br />
          <br />
          <Skeleton width={300} height={30} />
        </>
      ) : (
        links?.map((link) => {
          if (!link?.url?.en && !link?.url?.fr) return null
          return (
            <div key={link.linkType} className={styles['link-item']}>
              {iconMap[link.linkType] || null}
              <span>{link.title[currentLanguage]}</span>
              <NVButton
                variant='secondary'
                icon={<PwEyeIcon />}
                text={t('main.view')}
                onClick={() => window.open(link.url[currentLanguage], '_blank')}
              />
            </div>
          )
        })
      )}
    </div>
  )
}
